import { render, staticRenderFns } from "./GlobalEmpty.vue?vue&type=template&id=25d938c8&scoped=true"
import script from "./GlobalEmpty.vue?vue&type=script&lang=js"
export * from "./GlobalEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d938c8",
  null
  
)

export default component.exports